import { render } from "./container-details-requests.vue?vue&type=template&id=d50a872a&scoped=true"
import script from "./container-details-requests.vue?vue&type=script&lang=js"
export * from "./container-details-requests.vue?vue&type=script&lang=js"

import "./container-details-requests.vue?vue&type=style&index=0&id=d50a872a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d50a872a"]])

export default __exports__